import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['input'];

	connect() {
		this.toggleClass();
		this.inputTarget.addEventListener('focus', this.focus.bind(this));
		this.inputTarget.addEventListener('blur', this.blur.bind(this));
		this.inputTarget.addEventListener('input', this.toggleClass.bind(this));
	}

	disconnect() {
		this.inputTarget.removeEventListener('focus', this.focus.bind(this));
		this.inputTarget.removeEventListener('blur', this.blur.bind(this));
		this.inputTarget.removeEventListener('input', this.toggleClass.bind(this));
	}

	toggleClass() {
		if (this.inputTarget.value.trim() !== '' || document.activeElement === this.inputTarget) {
			this.element.classList.add('is-not-empty');
		} else {
			this.element.classList.remove('is-not-empty');
		}
	}

	focus() {
		this.element.classList.add('is-not-empty');
	}

	blur() {
		this.toggleClass();
	}
}
